import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { StoreType } from '@/store';
import { setCategoryInfo } from '@/store/category/action';
import { getDetails } from '@/utils/getData';
import Panel from '@/components/Panel';
import styles from './index.module.less';

const PAGE_SIZE = 10;

export interface ICategoryItem extends ICategory {
  total: number;
  hasMore?: boolean;
  isExpand?: boolean;
  lists?: IArticleItem[];
}

interface IProps {
  initialData: ICategoryItem[];
}

const SubCategories: React.FC<IProps> = ({ initialData }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [subCategories, setSubCategories] = useState<ICategoryItem[]>();

  const categoryInfo = useSelector((state: StoreType) => state.category);

  const expand = useCallback(
    async (item) => {
      dispatch(
        setCategoryInfo({
          expandId: item.isExpand ? null : item.id,
        }),
      );
      setSubCategories(
        subCategories.map((v) => ({
          ...v,
          isExpand: v.id === item.id ? !item.isExpand : false,
        })),
      );
    },
    [subCategories, dispatch],
  );

  const getArticleData = (articleIds) => {
    if (!articleIds?.length) return [];
    const newComingList: IArticleItem[] = [];
    articleIds.map((id) => {
      const current = getDetails(id);
      newComingList.push({
        id,
        title: current?.title,
      });
    });
    return newComingList;
  };

  const loadMoreArticles = async (item: ICategoryItem) => {
    const start = item?.lists?.length; // start slice position
    const articleIds = item.articles?.slice(start, start + PAGE_SIZE);
    item.lists = [...item.lists, ...getArticleData(articleIds)];
    item.hasMore = item.lists.length < item.total;
    setSubCategories([...subCategories]);
  };

  const preload = () => {
    initialData.forEach((item) => {
      item.total = item.articles?.length ?? 0;
      item.hasMore = item?.total > PAGE_SIZE;
      item.isExpand = item.id === categoryInfo.expandId;
      item.lists = getArticleData(item.articles?.slice(0, PAGE_SIZE));
    });
    setSubCategories(initialData);
  };

  useEffect(() => {
    preload();
  }, [initialData]);

  return (
    <div>
      {subCategories?.map((item, index) => {
        return (
          <Panel.Item
            key={index}
            text={item.name}
            hideLine={index === subCategories.length - 1 && !item.isExpand}
            textStyle={styles.categoryText}
            expandConfig={{
              expandable: !!item.lists?.length,
              isExpand: item.isExpand,
              childs: item.lists?.map((child) => ({
                ...child,
                text: child.title,
              })),
              onPressChild: (id) => history.push(`/details/${id}`),
              hasMore: item.hasMore,
              loadMore: async () => await loadMoreArticles(item),
            }}
            onPress={() => {
              expand(item);
            }}
          />
        );
      })}
    </div>
  );
};
export default SubCategories;
